import React from 'react';
import { User, UserX } from 'lucide-react';
import CompactSelectPicker from '../ui/CompactSelectPicker';

const OPTIONS = [
  { value: 'mine', label: 'Mine', Icon: User },
  { value: 'unassigned', label: 'Unassigned', Icon: UserX },
];

/** The filter state's two assignee flags as the picker's one value. */
export function assigneeFilterValue(filters) {
  if (filters?.mine) return 'mine';
  if (filters?.unassigned) return 'unassigned';
  return '';
}

/**
 * The Assignee filter chip of a TEAM board (Boards parity, 12.10.2026): the
 * former "Mine" and "Unassigned" toggle chips as one picker, built like the
 * Priority chip beside it (the shared CompactSelectPicker, counts in the
 * menu, "Anyone" under the list).
 *
 * Why one picker: the Main artboard has no assignee chips at all, and with
 * two of them the chip row of a team board no longer fitted on one line. The
 * two flags were never meaningfully combined anyway — "mine AND unassigned"
 * matches nothing — so one value at a time loses no filter.
 */
export default function BoardAssigneeFilter({ value = '', counts = {}, onChange }) {
  const on = OPTIONS.some((o) => o.value === value);
  const options = OPTIONS.map(({ value: v, label, Icon }) => ({
    value: v,
    label,
    leading: (
      <span className="board-filter-priority-option">
        <Icon size={12} strokeWidth={2.2} aria-hidden />
        <span className="board-filter-priority-count">{counts[v] ?? 0}</span>
      </span>
    ),
  }));
  const current = OPTIONS.find((o) => o.value === value);
  return (
    <CompactSelectPicker
      className={`board-filter-priority board-filter-assignee${on ? ' board-filter-priority--on' : ''}`}
      menuClassName="board-filter-priority-menu"
      value={on ? value : null}
      options={options}
      placeholder="Assignee"
      menuMinWidth={170}
      aria-label={on ? `Assignee filter: ${current.label}` : 'Filter by assignee'}
      onChange={(next) => onChange(next)}
      renderFooter={
        on
          ? ({ close }) => (
              <button
                type="button"
                className="board-filter-priority-any"
                onClick={() => {
                  onChange('');
                  close();
                }}
              >
                Anyone
              </button>
            )
          : null
      }
    />
  );
}
